import React, { useEffect } from 'react';

import { Box } from '@waglabs/box-next';
import {
  AppDownloadButton,
  Distribution,
} from '@waglabs/get-app-button';
import { Grid } from '@waglabs/grid';
import { Image } from '@waglabs/image-next';
import { Modal } from '@waglabs/seo-modals';
import { Typography } from '@waglabs/typography';

import DownloadAppDesktop from '../../assets/images/download-app-desktop.png';
import DownloadAppMobile from '../../assets/images/download-app-mobile.png';
import chat from '../../assets/svg/chat.svg';
import gpsTracking from '../../assets/svg/gps-tracking.svg';
import like from '../../assets/svg/like.svg';
import { ModalCloseIcon } from '../../assets/svg/ModalCloseIcon';
import offersPercent from '../../assets/svg/offers-percent.svg';
import securityCheck from '../../assets/svg/security-check.svg';
import { AppDownloadLink, MobileTakeoverModalLink } from '../../constants';
import { useMobileTakeoverDraft } from '../../hooks/useMobileTakeoverDraft';
import { getOS } from '../../utils/getOS';

import { ImageTypographyPair } from './ImageTypographyPair';
import { ScanMe } from './ScanMe';

export const MobileTakeoverModal = () => {
  const {
    addDraft,
    draft,
  } = useMobileTakeoverDraft({});

  useEffect(() => {
    if (draft?.hasBeenDismissed || draft?.isVisible) {
      return;
    }

    addDraft({
      isVisible: true,
    });
  }, [draft, addDraft]);

  const os = getOS();
  return (
    <Modal
      data-testid="mobile-takeover-modal"
      noCloseIconButton
      onRequestClose={() => addDraft({ visible: false, hasBeenDismissed: true })}
      isOpen={draft?.isVisible}
    >
      <Grid
        gridTemplateColumns="1fr auto"
        alignItems="start"
        backgroundImage={[DownloadAppMobile, DownloadAppDesktop]}
        maxWidth="100%"
      >

        <Image
          gridColumn="1/-1"
          maxWidth="100%"
          zIndex={1}
          src={[DownloadAppMobile, DownloadAppDesktop]}
        />
        <ModalCloseIcon
          data-testid="mobile-takeover-modal-close-button"
          onClick={() => addDraft({ visible: false, hasBeenDismissed: true })}
          zIndex={10}
          position="absolute"
          right="0"
          marginTop="10px"
          marginRight="10px"
          justifySelf="flex-end"
        />

        <Grid
          backgroundColor="white"
        >
          <Typography
            mt="8px"
            variant="h3"
            fontFamily="muliBold"
            textAlign="center"
          >
            Download the Wag! app
          </Typography>
          <Typography
            variant="h4"
            textAlign="center"
          >
            for the best experience
          </Typography>
          <Grid
            gridTemplateColumns="4r 1fr 6fr 1fr"
            gridTemplateRows="repeat(5, 1fr)"
            justifySelf="center"
            mt="20px"
          >

            <ImageTypographyPair
              gridRow="1"
              gridColumnImage="2/span 1"
              gridColumnText="3/span 1"
              marginTop={['2px', '4px']}
              src={gpsTracking}
              fontFamily={['muli', 'muliBold']}
            >
              GPS Tracking
            </ImageTypographyPair>

            <ImageTypographyPair
              gridRow="2"
              gridColumnImage="2/span 1"
              gridColumnText="3/span 1"
              marginTop={['2px', '4px']}
              src={chat}
              fontFamily={['muli', 'muliBold']}
            >
              Chat with Caregivers
            </ImageTypographyPair>

            <ImageTypographyPair
              gridRow="3"
              gridColumnImage="2/span 1"
              gridColumnText="3/span 1"
              marginTop={['2px', '4px']}
              src={like}
              fontFamily={['muli', 'muliBold']}
            >
              User reviews
            </ImageTypographyPair>

            <ImageTypographyPair
              gridRow="4"
              gridColumnImage="2/span 1"
              gridColumnText="3/span 1"
              marginTop={['2px', '4px']}
              src={securityCheck}
              fontFamily={['muli', 'muliBold']}
            >
              Enhanced data protection
            </ImageTypographyPair>

            <ImageTypographyPair
              gridRow="5"
              gridColumnImage="2/span 1"
              gridColumnText="3/span 1"
              marginTop={['2px', '2px']}
              src={offersPercent}
              fontFamily={['muli', 'muliBold']}
            >
              Exclusive offers
            </ImageTypographyPair>

          </Grid>
          <Grid
            my="20px"
          >
            {os === 'iOS' && (
              <AppDownloadButton
                width="160px"
                height="52px"
                justifySelf="center"
                display={['flex', 'none']}
                href={MobileTakeoverModalLink}
                distribution={Distribution.AppStore}
              />
            )}
            {os === 'Android' && (
              <AppDownloadButton
                width="160px"
                height="52px"
                justifySelf="center"
                display={['flex', 'none']}
                distribution={Distribution.PlayStore}
                href={MobileTakeoverModalLink}
              />
            )}

            <Box
              display={['none', null, 'block']}
            >
              <ScanMe
                deepLink={MobileTakeoverModalLink}
              />
            </Box>
          </Grid>

        </Grid>

      </Grid>
    </Modal>
  );
};
